module.exports = __webpack_public_path__ + "images/home/orientation/no-content.e25c676458c1f4cb280b.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/home/orientation/no-content.svg
// module id = deks
// module chunks = 13